import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import { BoxContainer, SrcInfoContainer } from '@nile/banyan/src/Utils/style';
import {
  getTranslatedText,
  AccessControl,
  DeleteModal,
  CascadeCard,
  BackgroundIcon
} from '@nile/components';
import TaskCard from '@nile/projects/src/Components/Cards/TaskStrip';
import { AttachmentsList } from '@nile/banyan/src/Components/Lists';
import {
  Button,
  ButtonGroup,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { sortBy } from 'lodash';

const TasksPreviewCard = ({ tasks, name }) => {
  return (
    <div className="fx fcol mb20">
      <div>
        <Heading element="h2">{name}</Heading>
      </div>
      {tasks?.length > 0
        ? tasks.map((task) => {
            return (
              <TaskCard
                task={task}
                index="view"
                disableEdit
                disableActions
                isTemplate
                enableDrag={false}
              />
            );
          })
        : ''}
    </div>
  );
};

class ProjectCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      templates: props.data ? props.data : [],
      selectedItems: props.data.length > 0 ? [props.data[0].templateId] : [],
      selectedTemplate: null,
      uioptions: []
    };
  }

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
      const { templates } = this.state;
      const item = templates.find((item) => {
        return item.templateId === selectedItem[selectedItem.length - 1];
      });
      this.renderSubItem(item);
    }
  };

  renderSubItem = (item) => {
    this.setState({ selectedTemplate: item });
  };

  componentDidMount() {
    if (this.props.data.length > 0) {
      this.renderSubItem(this.props.data[0]);
    }
  }

  deleteTemplate = (templateId) => {
    this.props.deleteTemplate({
      variables: {
        input: { templateId }
      }
    });
  };

  handleReplyChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { selectedTemplate, templates, selectedItems } = this.state;
    const { intl } = this.props;

    const processedAllItems = processData(templates, 'templateId');

    return (
      <div className="full-height">
        <div className="fx full-height white-transparent-bg">
          <div className="fx ch-20 full-width">
            <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
              <div className="full-width fx col">
                <div className="sticky-search">
                  <AutoComplete
                    options={processedAllItems}
                    handleChange={this.handleReplyChange}
                  />
                </div>
                <div className="cascade-list f11 scroll ch-50">
                  <ResourceList
                    items={templates}
                    selectedItems={selectedItems}
                    onSelectionChange={this.setSelectedItems}
                    renderItem={(item) => {
                      const { templateId: id, name } = item;
                      return (
                        <ResourceItem
                          id={id}
                          accessibilityLabel={`View details for ${name}`}
                        >
                          <div className="fw fx">
                            <TextStyle variation="strong">{name}</TextStyle>
                            {item.uioptions && item.uioptions.length > 0 ? (
                              <div className="iconHolder">
                                <SVGIcon name="ArrowRight" />
                              </div>
                            ) : (
                              <div />
                            )}
                          </div>
                        </ResourceItem>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            {selectedTemplate && (
              <div className="fx p2040 scroll w70">
                <div className="full-width">
                  <div className="flex actr m-0">
                    <div className="fx2">
                      <Heading element="h2">{selectedTemplate.name}</Heading>
                    </div>
                    <div
                      data-qa="rtOuterActions"
                      className="Reply-Templates-Actions"
                    >
                      <ButtonGroup>
                        <AccessControl
                          roleToCheck="projectTemplate.delete"
                          render={
                            <DeleteModal
                              description={getTranslatedText(
                                intl,
                                'admin.projectTemplates.delete.confirm'
                              )}
                              id="deleteTemplateBtn"
                              handleDeleteConfirmation={() =>
                                this.deleteTemplate(selectedTemplate.templateId)
                              }
                              title={getTranslatedText(
                                intl,
                                'admin.projectTemplates.delete.header'
                              )}
                            />
                          }
                        />
                        <AccessControl
                          roleToCheck="projectTemplate.edit"
                          render={
                            <Button
                              secondary
                              icon={
                                <div className="fx center">
                                  <SVGIcon name="Edit" />
                                </div>
                              }
                              url={
                                '#/onboard/projecttemplate/' +
                                selectedTemplate.templateId +
                                '/edit'
                              }
                            />
                          }
                        />
                      </ButtonGroup>
                    </div>
                  </div>
                  <div className="ch-50 scroll pt10 pb10 fcol fx">
                    <div className="fx mt10 mb40 ws-prewrap">
                      <TextStyle variation="subdued">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: dompurifier(selectedTemplate?.description)
                          }}
                        />
                      </TextStyle>
                    </div>
                    {selectedTemplate?.attachments?.length && (
                      <div className="fx mb40 fcol">
                        <div className="mb20">
                          <Heading element="h2">Attachments</Heading>
                        </div>
                        <AttachmentsList
                          attachmentsList={selectedTemplate?.attachments}
                          module="PROJECT_TEMPLATE_ATTACHMENT"
                          template={{ id: selectedTemplate?.templateId }}
                        />
                      </div>
                    )}
                    <div className="fx fcol">
                      {sortBy(
                        selectedTemplate?.milestones,
                        'milestoneOrder'
                      ).map(({ name, tasks }) => (
                        <TasksPreviewCard
                          tasks={sortBy(tasks, 'taskOrder')}
                          name={name}
                        />
                      ))}
                      {selectedTemplate?.tasks?.length && (
                        <TasksPreviewCard
                          tasks={sortBy(selectedTemplate?.tasks, 'taskOrder')}
                          name="Other tasks"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ProjectCascade);
